import { useContext, JSX } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {Handle, Position, useReactFlow, ReactFlowInstance, Node } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowSwitchNode({id, data}: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    // console.log(data);

    function setActiveEditSwitchNode(): void {
        const node: Node = reactFlowInstance.getNode(id);
        context.setActiveEditSwitchNode(node);
    }

    const conditions: any = data['conditions'] ?? [];

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node switch " + id + " "  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="switch-node-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className="switch-icon" />
                    <span className="label-span">
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Switch Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ setActiveEditSwitchNode }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            { conditions.map( (condition: any, index: number): JSX.Element => {
                const left: number = (100 / (conditions.length + 1));
                const leftValue: string = left * (index + 1) + '%';
                let label: string = `Condition ${(index + 1)}`;
                if (typeof condition.label === "string" && condition.label.length > 0) {
                    label = condition.label;
                }
                return (
                    <Handle key={ "switch_node_source_" + index }
                            type="source"
                            id={ "switch-node-source-" + index }
                            style={ { left: leftValue  } }
                            position={ Position.Bottom }>
                        <span className="handle-label bottom" >{ label }</span>
                    </Handle>
                );
            } ) }
            <Handle type="source"
                    id={ "switch-node-source-default" }
                    position={ Position.Right }>
                <span className="handle-label right" >{ "Default" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowSwitchNode;